import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/auth/authSlice";
import productsReducer from "../store/products/productsSlice";
import groceryListsReducer from "../store/groceryLists/groceryListsSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productsReducer,
    groceryLists: groceryListsReducer,
  },
});

